import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { APPS } from "../../../../constants/AppsConstants.ts";
import { useAppStore } from "../../../../hooks/useStores";
import { ImageEditingViewMode, ImageToImageConfigType, PlaygroundImage } from "../../../../models/image-to-image";
import { TextToImageConfigType } from "../../../../models/text-to-image.ts";
import iframeStore from "../../../IframeNew/iframe-store.tsx";
import ImageOverlayEditorButton from "./EditorButton/ImageOverlayEditorButton.tsx";
import ImageOverlayFeedbackButtons from "./FeedbackButtons/ImageOverlayFeedbackButtons.tsx";
import styles from "./PlaygroundImageOverlay.module.scss";
import ImageOverlayShareButton from "./ShareButton/ImageOverlayShareButton.tsx";

export type PlaygroundImageOverlayProps = {
	image: PlaygroundImage;
	videoButton?: boolean;
	hideAiEditorButton?: boolean;
};

export type Feedback = {
	appName: string;
	type: string;
	imageUrl: string;
	text?: string;
	modelName?: string;
	modelId?: string;
	seed?: number;
	configs?: TextToImageConfigType | ImageToImageConfigType;
	refImageUrl?: string;
};

export enum FeedbackTypeEnum {
	Positive = "Positive",
	Negative = "Negative",
}

const PlaygroundImageOverlay = ({ image, videoButton, hideAiEditorButton = false }: PlaygroundImageOverlayProps) => {
	const { playgroundStore } = useAppStore();

	const isSvg = (image.config as TextToImageConfigType)?.format === "svg";
	const isCampaign = image.type === APPS.CAMPAIGN;
	const isTextToImage = image.type === "textToImage";
	const isIframe = iframeStore.isIframe();
	const isFeedbackEnabled = iframeStore.iframe.config.general_config?.enable_feedback_buttons;
	const isImageToImageEnabled = iframeStore.iframe.config.enabled_pages.imageToImage;

	const showAiEditorButton =
		!isSvg &&
		!isCampaign &&
		!hideAiEditorButton &&
		!playgroundStore.isText2ImagePopupOpened &&
		(!isIframe || isImageToImageEnabled) &&
		(playgroundStore.selectedConfig === APPS.TEXT_TO_IMAGE ||
			playgroundStore.imageEditingViewMode === ImageEditingViewMode.GALLERY);

	const showFeedbackButtons = (!isIframe || isFeedbackEnabled) && !isCampaign;

	return (
		<Box className={clsx(styles.container, "container")}>
			<Box
				className={clsx(styles.imageFooter, {
					[styles.singleMode]: playgroundStore.imageEditingViewMode === ImageEditingViewMode.SINGLE,
				})}
			>
				{videoButton && <></>}
				{showAiEditorButton && <ImageOverlayEditorButton image={image} />}
				{isTextToImage && <ImageOverlayShareButton />}
				{showFeedbackButtons && <ImageOverlayFeedbackButtons image={image} />}
			</Box>
		</Box>
	);
};

export default observer(PlaygroundImageOverlay);
